<app-preloader></app-preloader>
<!-- <app-navbar *ngIf="!(location == '/coming-soon')"></app-navbar> -->
<router-outlet></router-outlet>
<!-- <app-footer *ngIf="!(location == '/coming-soon')"></app-footer> -->

<a href="https://wa.me/+917418426834" id="whatsapp" target="_blank">
    <img src="../assets/img//Chat.gif" style="height: 70px;">
    <!-- <i class='bx bxl-whatsapp'></i> -->
    <!-- <i class="fab fa-whatsapp"></i> -->
</a>
